<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>Filtrar bolsitas</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <template>
                                <v-form ref="searchProduct" v-model="valid">
                                  <v-container>
                                    <v-row
                                      cols="12"
                                      md="12"
                                    >
                                      <v-col>
                                        <v-checkbox
                                          v-model="filter.showCreatedOrders"
                                          label="¿Mostrar Ordenes Generadas?"
                                        ></v-checkbox>
                                      </v-col>
                                      <v-col
                                        cols="12"
                                        md="12"
                                      >
                                        <v-select
                                          v-model="filter.status"
                                          :items="select.status"
                                          item-value="id"
                                          item-text="name"
                                          label="Estado"
                                          :disabled="filter.showCreatedOrders"
                                          clearable
                                          dense
                                          outlined
                                        ></v-select>
                                      </v-col>

                                      <v-col
                                        cols="12"
                                        md="2"
                                      >
                                        <v-btn
                                          color="primary"
                                          block
                                          depressed
                                          @click="getReceivable()"
                                        >
                                          <v-icon dark>
                                            manage_search
                                          </v-icon>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-form>
                              </template>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-title>
                              <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Ingresar texto a buscar"
                                @input="onInputFindClient"
                                single-line
                                hide-details
                              ></v-text-field>
                            </v-card-title>
                            <v-data-table
                              :headers="headers"
                              :items="items"
                              :search="search"
                            >
                              <template v-slot:item.status="{ item }">
                                <template v-if="item.status == 0">
                                  <v-btn
                                    color="error"
                                    dark
                                  >
                                    <template v-if="!!item.orderId">
                                      ANULADO<br>N° orden {{item.orderId}}
                                    </template>
                                    <template v-else>
                                      BOLSITA<br>LIBERADA
                                    </template>
                                  </v-btn>
                                </template>
                              </template>
                              <template v-slot:item.actions="{ item }">
                                <v-row
                                  align="center"
                                  class="spacer"
                                  dense
                                >
                                  <v-btn
                                    depressed
                                    color="primary"
                                    @click="findReceivableForId(item.id); shoppingBagDialog = true"
                                    class="ma-2"
                                  >
                                    MODIFICAR BOLSITA
                                  </v-btn>
                                  <v-btn
                                    depressed
                                    color="primary"
                                    @click="findReceivableForId(item.id); dialog = true"
                                    class="ma-2"
                                  >
                                    PAGOS
                                  </v-btn>
                                  <v-btn
                                    depressed
                                    color="success"
                                    @click="findReceivableForId(item.id); confirmDialogGenerateOrder = true"
                                    class="ma-2"
                                    :disabled="!!item.orderId || item.status == 0"
                                  >
                                    GENERAR ORDEN
                                  </v-btn>
                                  <v-btn
                                    depressed
                                    color="error"
                                    @click="findReceivableForId(item.id); confirmDialogCancelShoppingBag = true"
                                    class="ma-2"
                                    :disabled="!!item.orderId || item.status == 0"
                                  >
                                    LIBERAR BOLSITA
                                  </v-btn>
                                  <v-btn
                                    depressed
                                    color="purple"
                                    @click="printTicket(item.partialOrderId)"
                                    class="ma-2"
                                    :disabled="item.status == 0"
                                  >
                                    <v-icon color="white">
                                      print
                                    </v-icon>
                                  </v-btn>
                                </v-row>
                              </template>
                            </v-data-table>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </template>
        </div>
      </template>

      <v-dialog
        v-model="dialog"
        lg
      >
        <v-card>
          <v-card-title class="primary dark">
            <template>
              <v-tabs
                  v-model="tab"
                  background-color="primary"
                  dark
              >
                <v-tab href="#tab-1">Detalle de Pagos</v-tab>
              </v-tabs>
            </template>
          </v-card-title>

          <v-card-text>
            <v-tabs-items v-model="tab">
              <v-tab-item
                key="1"
                value="tab-1"
              >
                <v-card flat>
                  <v-card-text>
                    <template>
                      <v-form ref="form" v-model="valid">
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              md="4"
                            >
                              <v-text-field
                                v-model="receivable.total"
                                label="Total"
                                outlined
                                dense
                                disabled
                              ></v-text-field>
                            </v-col>

                            <v-col
                              cols="12"
                              md="4"
                            >
                              <v-text-field
                                v-model="receivable.advancePayment"
                                label="Adelanto"
                                outlined
                                dense
                                disabled
                              ></v-text-field>
                            </v-col>

                            <v-col
                              cols="12"
                              md="4"
                            >
                              <v-text-field
                                v-model="receivable.pendingPayment"
                                label="Pendiente"
                                outlined
                                dense
                                disabled
                              ></v-text-field>
                            </v-col>

                            <v-col
                              cols="12"
                              md="4"
                            >
                              <v-text-field
                                v-model="payment"
                                label="Ingresar monto a pagar"
                                :rules="[rules.required]"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                            >
                              <v-dialog
                                ref="dialog"
                                v-model="modalPaymentDay"
                                :return-value.sync="date"
                                persistent
                                width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="dateText"
                                    label="Fecha de Registro"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="date"
                                  scrollable
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="modalPaymentDay = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.dialog.save(date)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-col>
                            <v-col
                              cols="12"
                              md="4"
                              class="text-right"
                            >
                              <v-btn
                                :disabled="!!receivable.orderId || receivable.status == 0"
                                color="primary"
                                block
                                depressed
                                @click="savePartialPayment"
                              >
                                REGISTRAR PAGO
                              </v-btn>
                            </v-col>
                          </v-row>
                          <v-row align="center" justify="center">
                            <v-col
                              cols="12"
                              md="10"
                              sm="10"
                            >
                              <v-data-table
                                :headers="receivableDetailHeaders"
                                :items="receivableDetailItems"
                              >
                                <template v-slot:item.actions="{ item }">
                                  <v-row
                                    align="center"
                                    class="spacer"
                                    no-gutters
                                  >
                                    <v-btn
                                      depressed
                                      color="primary"
                                      @click="selectedPaymentToDelete(item)"
                                      class="ma-2"
                                      :disabled="!!receivable.orderId || receivable.status == 0"
                                    >
                                      ELIMINAR
                                    </v-btn>
                                  </v-row>
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </template>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="adm_orange"
              text
              @click="dialog = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="shoppingBagDialog"
        lg
      >
        <v-card>
          <v-card-title class="primary dark">
            <template>
              <v-tabs
                  v-model="shoppingBagTab"
                  background-color="primary"
                  dark
              >
                <v-tab href="#tab-2">Detalle de Bolsita</v-tab>
              </v-tabs>
            </template>
          </v-card-title>

          <v-card-text>
            <v-tabs-items v-model="shoppingBagTab">
              <v-tab-item
                key="2"
                value="tab-2"
              >
                <v-card flat>
                  <v-card-text>
                    <template>
                      <v-form ref="formProductColor">
                        <v-container>
                          <template>
                            <v-row justify="center">
                              <v-col cols="12" md="12" xs="12">
                                <v-expansion-panels multiple v-model="panel">

                                  <v-expansion-panel>
                                    <v-expansion-panel-header class="tile">
                                      <v-row
                                        align="center"
                                        class="spacer"
                                        no-gutters
                                      >
                                        <v-col
                                          cols="4"
                                          sm="2"
                                          md="1"
                                        >
                                          <v-avatar size="36px">
                                            <v-icon color="red">person</v-icon>
                                          </v-avatar>
                                        </v-col>

                                        <v-col
                                          class="hidden-xs-only"
                                          sm="5"
                                          md="3"
                                        >
                                          <strong>DATOS DEL CLIENTE</strong>
                                        </v-col>
                                      </v-row>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                      <v-card flat>
                                        <v-card-text>
                                          <template>
                                            <v-form ref="searchProductForm">
                                              <v-container>
                                                <v-row>
                                                  <v-col
                                                    cols="12"
                                                    md="3"
                                                  >
                                                    <v-dialog
                                                      ref="modalDeliveryDayRef"
                                                      v-model="modalDeliveryDay"
                                                      :return-value.sync="deliveryDate"
                                                      persistent
                                                      width="290px"
                                                    >
                                                      <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                          v-model="deliveryDateText"
                                                          label="Fecha de Entrega"
                                                          readonly
                                                          v-bind="attrs"
                                                          v-on="on"
                                                          outlined
                                                          dense
                                                        ></v-text-field>
                                                      </template>
                                                      <v-date-picker
                                                        v-model="deliveryDate"
                                                        scrollable
                                                      >
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                          text
                                                          color="primary"
                                                          @click="modalDeliveryDay = false"
                                                        >
                                                          Cancel
                                                        </v-btn>
                                                        <v-btn
                                                          text
                                                          color="primary"
                                                          @click="$refs.modalDeliveryDayRef.save(deliveryDate)"
                                                        >
                                                          OK
                                                        </v-btn>
                                                      </v-date-picker>
                                                    </v-dialog>
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    md="3"
                                                    offset-md="6"
                                                  >
                                                    <v-dialog
                                                      ref="modalRegistrationDayRef"
                                                      v-model="modalRegistrationDay"
                                                      :return-value.sync="registrationDate"
                                                      persistent
                                                      width="290px"
                                                    >
                                                      <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                          v-model="registrationDateText"
                                                          label="Fecha de Apertura"
                                                          readonly
                                                          v-bind="attrs"
                                                          v-on="on"
                                                          outlined
                                                          dense
                                                        ></v-text-field>
                                                      </template>
                                                      <v-date-picker
                                                        v-model="registrationDate"
                                                        scrollable
                                                      >
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                          text
                                                          color="primary"
                                                          @click="modalRegistrationDay = false"
                                                        >
                                                          Cancel
                                                        </v-btn>
                                                        <v-btn
                                                          text
                                                          color="primary"
                                                          @click="$refs.modalRegistrationDayRef.save(registrationDate)"
                                                        >
                                                          OK
                                                        </v-btn>
                                                      </v-date-picker>
                                                    </v-dialog>
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    md="3"
                                                  >
                                                    <v-text-field
                                                      v-model="client.name"
                                                      label="Nombre"
                                                      :rules="[rules.required]"
                                                      outlined
                                                      dense
                                                      required
                                                    ></v-text-field>
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    md="3"
                                                  >
                                                    <v-text-field
                                                      v-model="client.last_name"
                                                      label="Apellido"
                                                      :rules="[rules.required]"
                                                      outlined
                                                      dense
                                                      required
                                                    ></v-text-field>
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    md="3"
                                                  >
                                                    <v-text-field
                                                      v-model="client.identification_doc"
                                                      label="DNI/CE"
                                                      outlined
                                                      dense
                                                      required
                                                    ></v-text-field>
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    md="3"
                                                  >
                                                    <v-text-field
                                                      v-model="client.phone"
                                                      label="Celular"
                                                      :rules="[rules.required]"
                                                      outlined
                                                      dense
                                                      required
                                                    ></v-text-field>
                                                  </v-col>
                                                  <v-col
                                                    cols="12"
                                                    md="4"
                                                  >
                                                    <v-select
                                                      v-model="address.shipping_type_id"
                                                      :items="select.deliveryTypes"
                                                      item-value="id"
                                                      item-text="name"
                                                      label="Tipo de Entrega"
                                                      dense
                                                      outlined
                                                      clearable
                                                    ></v-select>
                                                  </v-col>

                                                  <template v-if="address.shipping_type_id == 1 || address.shipping_type_id == 2">
                                                    <v-col
                                                      cols="12"
                                                      md="4"
                                                    >
                                                      <v-select
                                                        v-model="address.department_id"
                                                        :items="address.shipping_type_id == 1 ? select.departments : filteredDepartments"
                                                        item-value="id"
                                                        item-text="name"
                                                        label="Departamento"
                                                        dense
                                                        outlined
                                                      ></v-select>
                                                    </v-col>

                                                    <v-col
                                                      cols="12"
                                                      md="4"
                                                    >
                                                      <v-select
                                                        v-model="address.province_id"
                                                        :items="address.shipping_type_id == 1 ? select.provinces : filteredProvinces"
                                                        item-value="id"
                                                        item-text="name"
                                                        label="Provincia"
                                                        dense
                                                        outlined
                                                      ></v-select>
                                                    </v-col>

                                                    <v-col
                                                      cols="12"
                                                      md="4"
                                                    >
                                                      <v-select
                                                        v-model="address.district_id"
                                                        :items="address.shipping_type_id == 1 ? select.districts : filteredDistricts"
                                                        item-value="id"
                                                        item-text="name"
                                                        label="Distrito"
                                                        dense
                                                        outlined
                                                      ></v-select>
                                                    </v-col>
                                                  </template>

                                                  <v-col
                                                    cols="12"
                                                    md="8"
                                                  >
                                                    <v-text-field
                                                      v-model="address.address"
                                                      label="Dirección"
                                                      outlined
                                                      dense
                                                      required
                                                    ></v-text-field>
                                                  </v-col>

                                                  <v-col
                                                    cols="12"
                                                    md="4"
                                                    offset-md="8"
                                                  >
                                                    <v-btn
                                                      :disabled="(partialOrderItems.length == 0 ? true : false) || !!receivable.orderId || receivable.status == 0"
                                                      color="primary"
                                                      block
                                                      depressed
                                                      @click="updateSale()"
                                                    >
                                                      ACTUALIZAR TIPO DE ENTREGA
                                                    </v-btn>
                                                  </v-col>
                                                </v-row>
                                              </v-container>
                                            </v-form>
                                          </template>
                                        </v-card-text>
                                      </v-card>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>

                                  <v-expansion-panel key="addProduct" hide-actions>
                                    <v-expansion-panel-header>
                                      <v-row
                                        align="center"
                                        class="spacer"
                                        no-gutters
                                      >
                                        <v-col
                                          cols="4"
                                          sm="2"
                                          md="1"
                                        >
                                          <v-avatar size="36px">
                                            <v-icon color="red">add_shopping_cart</v-icon>
                                          </v-avatar>
                                        </v-col>

                                        <v-col
                                          class="hidden-xs-only"
                                          sm="5"
                                          md="3"
                                        >
                                          <strong>AGREGAR PRODUCTOS AL DETALLE</strong>
                                        </v-col>
                                      </v-row>
                                    </v-expansion-panel-header>

                                    <v-expansion-panel-content>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-container>
                                          <v-row justify="center">
                                            <v-col cols="12" md="12" xs="12">
                                              <v-row>
                                                <v-col cols="12" md="8" xs="12">
                                                  <v-row>
                                                    <v-col
                                                      cols="12"
                                                      md="12"
                                                    >
                                                      <v-select
                                                        v-model="selected.product"
                                                        :items="select.products"
                                                        item-value="id"
                                                        item-text="name"
                                                        label="Productos"
                                                        dense
                                                        outlined
                                                      >
                                                        <template v-slot:prepend-item>
                                                          <v-list-item>
                                                            <v-list-item-content>
                                                              <v-text-field
                                                                v-model="searchProduct"
                                                                placeholder="Buscar"
                                                                @input="searchArticulos"
                                                                dense
                                                                outlined
                                                              ></v-text-field>
                                                            </v-list-item-content>
                                                          </v-list-item>
                                                          <v-divider class="mt-2"></v-divider>
                                                        </template>
                                                      </v-select>
                                                    </v-col>
                                                    <v-col
                                                      cols="12"
                                                      md="5"
                                                    >
                                                      <v-select
                                                        v-model="selected.productColor"
                                                        :items="select.productColors"
                                                        item-value="id"
                                                        item-text="color.name"
                                                        label="Colores"
                                                        dense
                                                        outlined
                                                      ></v-select>
                                                    </v-col>
                                                    <v-col
                                                      cols="12"
                                                      md="5"
                                                    >
                                                      <v-select
                                                        v-model="selected.productColorSize"
                                                        :items="select.productColorSizes"
                                                        item-value="id"
                                                        item-text="size.name"
                                                        label="Tallas"
                                                        dense
                                                        outlined
                                                      ></v-select>
                                                    </v-col>
                                                    <v-col
                                                      cols="12"
                                                      md="2"
                                                      class="d-flex"
                                                    >
                                                      <v-text-field
                                                        v-model="stock"
                                                        label="Stock"
                                                        :background-color="stock && stock > 0 ? 'green' : 'red'"
                                                        outlined
                                                        dense
                                                        disabled
                                                      ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                      cols="12"
                                                      md="4"
                                                    >
                                                      <v-text-field
                                                        :label="`Precio Unitario ${(off ? off + '% dsc' : '')}`"
                                                        :value="unit_price"
                                                        disabled
                                                        outlined
                                                        dense
                                                      ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                      cols="12"
                                                      md="4"
                                                    >
                                                      <v-text-field
                                                        v-model="quantity"
                                                        label="Cantidad"
                                                        type="number"
                                                        outlined
                                                        dense
                                                      ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                      cols="12"
                                                      md="4"
                                                    >
                                                      <v-btn
                                                        :disabled="(!quantity || quantity <= 0) || stock <= 0 || !!receivable.orderId"
                                                        color="primary"
                                                        block
                                                        depressed
                                                        @click="addProduct"
                                                      >
                                                        AGREGAR PRODUCTO
                                                      </v-btn>
                                                    </v-col>
                                                  </v-row>
                                                </v-col>

                                                <v-col cols="12" md="4" xs="12">
                                                  <v-row justify="center">
                                                    <v-col
                                                      cols="12"
                                                      md="6"
                                                    >
                                                      <v-card style="border: 0" outlined elevation="0">
                                                        <v-img
                                                          :src="productColorImageUrl"
                                                          :key="productColorImageUrl"
                                                          height="auto"
                                                        >
                                                          <template v-slot:placeholder>
                                                            <v-row
                                                              class="fill-height ma-0"
                                                              align="center"
                                                              justify="center"
                                                            >
                                                              <v-progress-circular
                                                                indeterminate
                                                                color="primary lighten-5"
                                                              ></v-progress-circular>
                                                            </v-row>
                                                          </template>
                                                          <template v-if="off">
                                                            <div class="text-right">
                                                              <v-chip
                                                                class="ma-0 short"
                                                                color="pink"
                                                                label
                                                                text-color="white"
                                                              >
                                                                <v-icon left>
                                                                  mdi-label
                                                                </v-icon>
                                                                <b class="body-2">- {{ off }}%</b>
                                                              </v-chip>
                                                            </div>
                                                          </template>
                                                        </v-img>
                                                      </v-card>
                                                    </v-col>
                                                  </v-row>
                                                </v-col>
                                              </v-row>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-card-text>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>

                                  <v-expansion-panel key="partialOrderDetail" hide-actions>
                                    <v-expansion-panel-header>
                                      <v-row
                                        align="center"
                                        class="spacer"
                                        no-gutters
                                      >
                                        <v-col
                                          cols="4"
                                          sm="2"
                                          md="1"
                                        >
                                          <v-avatar size="36px">
                                            <v-icon color="red">shopping_cart</v-icon>
                                          </v-avatar>
                                        </v-col>

                                        <v-col
                                          class="hidden-xs-only"
                                          sm="5"
                                          md="3"
                                        >
                                          <strong>DETALLE DE VENTA</strong>
                                        </v-col>
                                      </v-row>
                                    </v-expansion-panel-header>

                                    <v-expansion-panel-content>
                                      <v-divider></v-divider>
                                      <v-card-text>
                                        <v-container>
                                          <v-row>
                                            <v-col cols="12">
                                              <v-data-table
                                                :headers="partialOrderHeaders"
                                                :items="partialOrderItems"
                                              >
                                                <template v-slot:item.accion="{ item, index }">
                                                  <v-btn
                                                    :disabled="!!receivable.orderId || receivable.status == 0"
                                                    depressed
                                                    color="primary"
                                                    @click="removeRow(index, item)"
                                                  >
                                                    QUITAR PRODUCTO
                                                  </v-btn>
                                                </template>
                                              </v-data-table>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="3"
                                              offset-md="9"
                                            >
                                              <v-text-field
                                                v-model="partialOrder.subtotal"
                                                label="Subtotal"
                                                outlined
                                                dense
                                                disabled
                                              ></v-text-field>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="3"
                                              offset-md="9"
                                              class="mt-n10"
                                            >
                                              <v-text-field
                                                v-model="partialOrder.shipping_price"
                                                label="Costo de Entrega"
                                                outlined
                                                dense
                                              ></v-text-field>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="3"
                                              offset-md="9"
                                              class="mt-n10"
                                            >
                                              <v-text-field
                                                v-model="partialOrder.coupon"
                                                label="Dsc Cupón (-)"
                                                outlined
                                                dense
                                              ></v-text-field>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="3"
                                              offset-md="9"
                                              class="mt-n10"
                                            >
                                              <v-text-field
                                                v-model="partialOrder.total"
                                                label="Total"
                                                outlined
                                                dense
                                                disabled
                                              ></v-text-field>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="3"
                                              offset-md="9"
                                              class="mt-n10"
                                            >
                                              <v-text-field
                                                v-model="partialOrder.advance_payment"
                                                label="Adelanto (-)"
                                                outlined
                                                dense
                                                disabled
                                              ></v-text-field>
                                            </v-col>
                                            <v-col
                                              cols="12"
                                              md="3"
                                              offset-md="9"
                                              class="mt-n10"
                                            >
                                              <v-text-field
                                                v-model="partialOrder.pending_payment"
                                                label="Pendiente"
                                                outlined
                                                dense
                                                disabled
                                              ></v-text-field>
                                            </v-col>
                                          </v-row>
                                        </v-container>
                                      </v-card-text>
                                    </v-expansion-panel-content>
                                  </v-expansion-panel>

                                </v-expansion-panels>
                              </v-col>
                            </v-row>
                          </template>
                        </v-container>
                      </v-form>
                    </template>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="adm_orange"
              text
              @click="shoppingBagDialog = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="confirmDialogDelete"
        persistent
        max-width="600"
      >
        <v-card>
          <v-card-title class="text-h5">
            Desea eliminar este pago realizado?
          </v-card-title>
          <v-card-text>Al eliminar este pago realizado, se realizará nuevamente el cálculo del monto pagado y del monto pendiente.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="error"
              @click="cofirmDeletion(false)"
            >
              Cancelar
            </v-btn>
            <v-btn
              depressed
              color="primary"
              @click="cofirmDeletion(true)"
            >
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="confirmDialogGenerateOrder"
        persistent
        max-width="600"
      >
        <v-card>
          <v-card-title class="text-h5">
            ¿Desea generar la orden de compra para esta bolsita aperturada?
          </v-card-title>
          <v-card-text>
            <template v-if="this.receivable.pendingPayment == 0 || this.receivable.pendingPayment == null">
              Esta bolsita no cuenta con saldo pendiente. ¿Desea generar su orden de compra?
            </template>
            <template v-else>
              Esta bolsita tiene un saldo pendiente de {{this.receivable.pendingPayment}}. ¿Desea generar su orden de compra de todas maneras?
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="error"
              @click="cofirmGenerateOrder(false)"
            >
              Cancelar
            </v-btn>
            <v-btn
              depressed
              color="primary"
              @click="cofirmGenerateOrder(true)"
            >
              Generar Orden
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="confirmDialogCancelShoppingBag"
        persistent
        max-width="600"
      >
        <v-card>
          <v-card-title class="text-h5">
            ¿Desea anular la bolsita aperturada?
          </v-card-title>
          <v-card-text>
            Al anular esta bolsita ya no se podrá generar su orden de compra y el stock de los productos de esta bolsita se repondran al inventario.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="error"
              @click="cofirmCancelShoppingBag(false)"
            >
              Cancelar
            </v-btn>
            <v-btn
              depressed
              color="primary"
              @click="cofirmCancelShoppingBag(true)"
            >
              Anular Bolsita
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <template>
        <div class="text-center ma-2">
          <v-snackbar
            v-model="snackbar"
            :color="color"
            top
            z-index="500"
          >
            {{text}}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
        </div>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'
  import {
    formatReceivableList, 
    formatReceivableDetailList, 
    formatReceivableModel,
    formatDateDB,
    formatPartialOrderModel,
    formatClientModel,
    formatAddressModel,
    formatPartialOrderDetailModel
  } from '@/utils/order/index'
  import {
    normalizeApiError
  } from '@/utils/error/index'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'ReceivableView',
    components: {
      DefaultLayout
    },
    data () {
      return {
        overlay: false,
        panel: [0, 2],
        search: '',
        headers: [
          { text: 'CLIENTE', value: 'clientName'},
          { text: 'CELULAR', value: 'phone'},
          { text: 'FECHA APERTURA', value: 'openingDate' },
          { text: 'FECHA DE ENTREGA', value: 'deliveryDay' },
          { text: 'TOTAL', value: 'total'},
          { text: 'ADELANTO', value: 'advancePayment' },
          { text: 'PENDIENTE', value: 'pendingPayment' },
          { text: '', value: 'status', filterable: false, sortable: false },
          { text: '', value: 'actions', filterable: false, sortable: false }
        ],
        items: [],
        dialog: false,
        tab: null,
        shoppingBagDialog: false,
        shoppingBagTab: null,
        receivable: {
          id: null,
          partialOrderId: null,
          total: null,
          advancePayment: null,
          pendingPayment: null,
          orderId: null
        },
        payment: null,
        paymentDate: null,
        valid: true,
        rules: {
          required: v => !!v || 'Por favor completar este campo'
        },
        receivableDetailHeaders: [
          { text: 'PAGO', value: 'payment'},
          { text: 'FECHA DE PAGO', value: 'paymentDate'},
          { text: '', value: 'actions', filterable: false, sortable: false }
        ],
        receivableDetailItems: [],
        confirmDialogDelete: false,
        paymentToDelete: {
          id: null,
          receivableId: null,
          payment: null,
          paymentDate: null
        },
        modalPaymentDay: false,
        date: moment().toISOString().substr(0, 10),
        confirmDialogGenerateOrder: false,
        confirmDialogCancelShoppingBag: false,
        receivableToGenerateOrder: {
          id: null,
          advancePayment: null,
          clientName: null,
          openingDate: null,
          partialOrderId: null,
          pendingPayment: null,
          phone: null,
          total: null
        },
        // ********** partial order *********
        modalDeliveryDay: false,
        modalRegistrationDay: false,
        deliveryDate: moment().toISOString().substr(0, 10),
        registrationDate: moment().toISOString().substr(0, 10),
        provinces: [],
        districts: [],
        deliveryDistricts: [],
        searchProduct: '',
        productCopy: [],
        productColorSizes: [],
        select: {
          deliveryTypes: [
            { id: 1, name: 'DELIVERY' },
            { id: 2, name: 'RETIRO EN TIENDA' },
            { id: 3, name: 'SHALOM, MARVISUR U OTRO' }
          ],
          departments: [],
          provinces: [],
          districts: [],
          products: [],
          productColors: [],
          productColorSizes: [],
          status: [
            { id: 1, name: 'BOLSITA ABIERTA' },
            { id: 0, name: 'BOLSITA LIBERADA' }
          ]
        },
        selected: {
          product: null,
          productColor: null,
          productColorSize: null,
        },
        productColorImageUrl: null,
        partialOrder: {
          id: null,
          client_id: null,
          address_id: null,
          payment_type_id: null,
          shipping_type_id: null,
          shipping_price: null,
          subtotal: null,
          coupon: null,
          total: null,
          advance_payment: null,
          pending_payment: null,
          delivery_day: null,
          coupon_code: null,
          opening_date: null
        },
        client: {
          id: null,
          email: null,
          name: null,
          last_name : null,
          identification_doc : null,
          phone: null,
          accept_conditions: 1,
          status: 1
        },
        address: {
          id: null,
          shipping_type_id: null,
          client_id: null,
          department_id: null,
          province_id: null,
          district_id: null,
          address: null,
          reference: null,
          primary: 1,
          status: 1
        },
        unit_price: null,
        quantity: null,
        off: null,
        stock: null,
        partialOrderHeaders: [
          { text: 'PRODUCTO', value: 'product_name', width: '25%' },
          { text: 'COLOR', value: 'product_color_name', width: '10%' },
          { text: 'TALLA', value: 'product_color_size_name', width: '10%' },
          { text: 'UNI.', value: 'quantity', width: '10%' },
          { text: 'PRECIO UNI.', value: 'unit_price', width: '15%' },
          { text: 'TOTAL', value: 'amount', width: '20%' },
          { text: 'ACCIONES', value: 'accion', filterable: false, sortable: false, width: '10%' }
        ],
        partialOrderItems: [],
        tab: null,
        expanded: [],
        validForm: true,
        searchClientTable: '',
        radioGroup: null,
        // ************ filters *************
        filter: {
          showCreatedOrders: false,
          status: 1
        },
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    computed: {
      dateText () {
        this.paymentDate = this.date;
        return formatDateDB(this.date);
      },
      deliveryDateText () {
        this.partialOrder.delivery_day = this.deliveryDate;
        return formatDateDB(this.deliveryDate);
      },
      registrationDateText () {
        this.partialOrder.opening_date = this.registrationDate;
        return formatDateDB(this.registrationDate);
      },
      filteredDepartments() {
        return this.select.departments.filter(item => item.store == 1)
      },

      filteredProvinces() {
        return this.select.provinces.filter(item => item.store == 1)
      },
      filteredDistricts() {
        return this.select.districts.filter(item => item.store == 1)
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },

      onInputFindClient(value) {
        // Si el valor contiene al menos un dígito
        if (/^[0-9\s]+$/.test(value)) {
          // Elimina todos los espacios
          this.search = value.replace(/\s+/g, '');
        } else {
          // Si no es numérico, deja el texto como está
          this.search = value;
        }
      },

      getReceivable() {
        this.overlay = true;

        const status = this.filter.status;
        const showCreatedOrders = this.filter.showCreatedOrders;
        const URL = process.env.DINO.PATH.GET_RECEIVABLE.replace(
          ':status', status).replace(':showCreatedOrders', showCreatedOrders);

        axios.get(URL)
        .then(response => {
          this.items = formatReceivableList(response.data);
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      findReceivableForId(id) {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.FIND_RECEIVABLE.replace(':id', id))
        .then(response => {
          this.receivable = formatReceivableModel(response.data);
          this.partialOrder = formatPartialOrderModel(response.data.partial_order);
          this.client = formatClientModel(response.data.partial_order.client);
          this.address = formatAddressModel(response.data.partial_order.address);
          this.deliveryDate = response.data.partial_order.delivery_day ? 
            response.data.partial_order.delivery_day.substring(0, 10) : null;
          this.registrationDate = response.data.partial_order.opening_date ? 
            response.data.partial_order.opening_date.substring(0, 10) : null;
          this.partialOrderItems = formatPartialOrderDetailModel(
            response.data.partial_order.partial_order_detail);
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.findReceivableDetail(id);
          this.overlay = false;
        });
      },

      findReceivableDetail(receivableId) {
        this.overlay = true;
        axios.get(process.env.DINO.PATH.FIND_RECEIVABLE_DETAIL.replace(':receivableId', receivableId))
        .then(response => {
          this.receivableDetailItems = formatReceivableDetailList(response.data);
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },

      savePartialPayment() {
        this.overlay = true;

        const request = {
          payment: this.payment,
          paymentDate: this.paymentDate,
          receivableId: this.receivable.id,
          partialOrderId: this.receivable.partialOrderId
        };

        axios.post(process.env.DINO.PATH.SAVE_PARTIAL_PAYMENT, request)
        .then(response => {
          this.showMessage(response.data.message, response.data.success ? 'green' : 'red');
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.findReceivableForId(this.receivable.id);
          this.getReceivable();
          this.payment = null;
          this.overlay = false;
        });
      },

      cleanReceivableSelected() {
        this.receivable.id = null;
        this.receivable.partialOrderId = null;
        this.receivable.total = null;
        this.receivable.advancePayment = null;
        this.receivable.pendingPayment = null;
        this.receivable.orderId = null
        this.payment = null;
      },

      selectedPaymentToDelete(item) {
        this.paymentToDelete.id = item.id;
        this.paymentToDelete.receivableId = item.receivableId;
        this.paymentToDelete.payment = item.payment;
        this.paymentToDelete.paymentDate = item.paymentDate;
        this.confirmDialogDelete = true;
      },

      cofirmDeletion(deletePaymemnt) {
        if (deletePaymemnt) {
          this.deletedPayment(this.paymentToDelete);
        } else {
          this.paymentToDelete.id = null;
          this.paymentToDelete.receivableId = null;
          this.paymentToDelete.payment = null;
          this.paymentToDelete.paymentDate = null;
        }
        this.confirmDialogDelete = false;
      },

      deletedPayment(item) {
        axios.post(process.env.DINO.PATH.DELETE_RECEIVABLE_DETAIL.replace(':id', item.id))
        .then(response => {
          this.showMessage(response.data.message, response.data.success ? 'green' : 'red');
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.findReceivableForId(item.receivableId);
        });
      },

      cleamShoppingBag() {
        this.selected.product = null;
        this.selected.productColor = null;
        this.selected.productColorSize = null;

        this.productColorImageUrl = null;

        this.partialOrder.id = null;
        this.partialOrder.client_id = null;
        this.partialOrder.address_id = null;
        this.partialOrder.payment_type_id = null;
        this.partialOrder.shipping_type_id = null;
        this.partialOrder.shipping_price = null;
        this.partialOrder.subtotal = null;
        this.partialOrder.coupon = null;
        this.partialOrder.total = null;
        this.partialOrder.advance_payment = null;
        this.partialOrder.pending_payment = null;
        this.partialOrder.delivery_day = null;
        this.partialOrder.coupon_code = null;
        this.partialOrder.opening_date = null;

        this.client.id = null;
        this.client.email = null;
        this.client.name = null;
        this.client.last_name = null;
        this.client.identification_doc = null;
        this.client.phone = null;
        this.client.accept_conditions = 1;
        this.client.status = 1;

        this.address.id = null;
        this.address.shipping_type_id = null;
        this.address.client_id = null;
        this.address.department_id = null;
        this.address.province_id = null;
        this.address.district_id = null;
        this.address.address = null;
        this.address.reference = null;
        this.address.primary = 1;
        this.address.status = 1;

        this.unit_price = null;
        this.quantity = null;
        this.off = null;
        this.stock = null;
        this.partialOrderItems = [];
      },

      cofirmGenerateOrder(deletePaymemnt) {
        if (deletePaymemnt) {
          this.generateOrder();
        } else {
          this.confirmDialogGenerateOrder = false;
        }
      },

      generateOrder() {
        if (!this.partialOrder.delivery_day) {
          this.showMessage(`Para generar su orden de compra debe ingresar la FECHA DE ENTREGA.`, 'deep-purple accent-4');
          return;
        }

        if (!this.address.shipping_type_id) {
          this.showMessage(`Para generar su orden de compra debe seleccionar el TIPO DE ENTREGA.`, 'deep-purple accent-4');
          return;
        }

        if (!this.address.address) {
          this.showMessage('Para generar su orden de compra debe ingresar una DIRECCIÓN de entrega.', 'deep-purple accent-4');
          return;
        }

        if (this.partialOrder.total < 0) {
          this.showMessage(`Para generar su orden de compra, el TOTAL no debe ser negativo.`, 'deep-purple accent-4');
          return;
        }

        axios.post(process.env.DINO.PATH.GENERATE_ORDER, 
          {'partialOrderId': this.receivable.partialOrderId})
        .then(response => {
          this.showMessage(response.data.message, response.data.success ? 'green' : 'red');
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.getReceivable();
          this.confirmDialogGenerateOrder = false;
        });
      },

      cofirmCancelShoppingBag(cancelShoppingBag) {
        if (cancelShoppingBag) {
          this.cancelShoppingBag();
        } else {
          this.confirmDialogCancelShoppingBag = false;
        }
      },

      cancelShoppingBag() {
        axios.post(process.env.DINO.PATH.RECEIVABLE_CANCEL, {
            'id': this.receivable.id,
            'partialOrderId': this.receivable.partialOrderId
        })
        .then(response => {
          this.showMessage(response.data.message, response.data.success ? 'green' : 'red');
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.getReceivable();
          this.confirmDialogCancelShoppingBag = false;
        });
      },

      getDeliveryDistricts () {
        axios.get(process.env.DINO.PATH.GET_DELIVERIES)
        .then(response => {
          this.select.departments = response.data.departments;
          this.provinces = response.data.provinces;
          this.districts = response.data.districts;
          this.deliveryDistricts = response.data.deliveryDistricts;
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      getProducts () {
        axios.get(process.env.DINO.PATH.GET_PRODUCTS)
        .then(response => {
          this.select.products = response.data;
          this.productCopy = [...response.data];
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      searchArticulos(e) {
        if (!this.searchProduct) {
          this.select.products = this.productCopy;
        }

        this.select.products = this.productCopy.filter((product) => {
          return product.name.toLowerCase().indexOf(this.searchProduct.toLowerCase()) > -1;
        });
      },

      getProductColors () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLORS.replace(':product_id', this.selected.product))
        .then(response => {
          this.select.productColors = response.data;
        })
        .catch(err => {
        })
        .then(() => {
        });
      },

      getProductColorSizes () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLOR_SIZES.replace(':product_id', this.selected.product))
        .then(response => {
          this.productColorSizes = response.data
        })
        .catch(err => {
        })
        .then(() => {
          if (this.select.productColors.length == 1 && this.select.productColors[0].color.name == 'NOT_COLOR') {
            this.selected.productColor = this.select.productColors[0].id;
          }
        });
      },

      validateStock() {
        this.partialOrderItems.forEach(function(obj) {
          amount = parseFloat(amount) + parseFloat(obj.amount);
          amount = parseFloat(amount).toFixed(2);
        });
      },

      addProduct () {
        const request = {
          'partialOrderId': this.partialOrder.id,
          'productId': this.selected.product,
          'productColorId': this.selected.productColor,
          'productColorSizeId': this.selected.productColorSize,
          'quantity': this.quantity,
          'receivableId': this.receivable.id
        };

        axios.post(process.env.DINO.PATH.ADD_PRODUCTO_TO_PARTIAL_ORDER, request)
        .then(response => {
          const color = response.data.success ? 'green' : 'red';
          this.showMessage(response.data.message, color);

          this.selected.product = null;
          this.selected.productColor = null;
          this.selected.productColorSize = null;
          this.select.productColors = [];
          this.select.productColorSizes = [];
          this.quantity = null;
          this.unit_price = null;
          this.off = null;
          this.productColorImageUrl = null;
          this.stock = null;

          this.findReceivableForId(this.receivable.id);
          this.getReceivable();
        })
        .catch(err => {
          if (err.response && err.response.data) {
            const apiError = normalizeApiError(err.response.data);
            this.showMessage(apiError.message, 'red');
          } else {
            this.showMessage('Hubo un problema en el servidor', 'red');
          }
        });
      },

      getProductImagesForTypeAndColor () {
        axios.get(process.env.DINO.PATH.GET_PRODUCT_COLOR_IMAGES_FOR_TYPE_AND_COLOR
          .replace(':product_color_id', this.selected.productColor)
          .replace(':type', 'mediano')
        )
        .then(response => {
          const self = this;
          response.data.forEach(function(obj) {
            if (obj.order == 1) {
              self.productColorImageUrl = obj.image;
            }
          });
        })
        .catch(err => {
        });
      },

      calculeAmounts() {
        const subtotal = this.partialOrder.subtotal ? parseFloat(this.partialOrder.subtotal) : 0;
        const shippingPrice = this.partialOrder.shipping_price ? parseFloat(this.partialOrder.shipping_price) : 0;
        const coupon = this.partialOrder.coupon ? parseFloat(this.partialOrder.coupon) : 0;
        const total = parseFloat(subtotal + shippingPrice - coupon).toFixed(2);
        const advancePayment = this.partialOrder.advance_payment ? parseFloat(this.partialOrder.advance_payment) : 0;

        this.partialOrder.total = total;
        this.partialOrder.pending_payment = parseFloat(total - advancePayment).toFixed(2);
      },

      removeRow: function (index, item) {
        axios.post(process.env.DINO.PATH.DELETE_PARTIAL_ORDER_DETAIL_BY_ID, {
          'partialOrderDetailId': item.id, 
          'partialOrderId': this.partialOrder.id,
          'receivableId': this.receivable.id
        })
        .then(response => {
          const color = response.data.success ? 'green' : 'red';
          this.showMessage(response.data.message, color);
        })
        .then(() => {
          this.findReceivableForId(this.receivable.id);
          this.getReceivable();
        })
        .catch(err => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        });
      },

      updateSale() {
        if (this.partialOrder.total < 0) {
          this.showMessage(`Para actualizar su bolsita, el TOTAL no debe ser genativo.`, 'deep-purple accent-4');
          return;
        }

        const request = {
          'client': this.client,
          'address': this.address,
          'partialOrder': this.partialOrder,
          'receivable': this.receivable,
          'partialOrderDetail': this.partialOrderItems
        };

        axios.post(process.env.DINO.PATH.UPDATE_PARTIAL_ORDER, request)
        .then(response => {
          const color = response.data.success ? 'green' : 'red';
          this.showMessage(response.data.message, color);
          this.getReceivable();
        })
        .catch(err => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        });
      },

      cleanAddress() {
        this.address.department_id = null;
        this.address.province_id = null;
        this.address.district_id = null;
      },

      printTicket(partialOrderId) {
        this.overlay = true;
        axios.post(
          process.env.DINO.PATH.GENERATE_TICKET, {
            'partialOrderId': partialOrderId
          }, {
          responseType: 'blob'
        })
        .then(response => {
          const fileURL = URL.createObjectURL(response.data);
          let a = document.createElement('a')
          a.setAttribute('href', fileURL)
          a.setAttribute('download', response.headers['name-file'])
          a.click()
        })
        .catch((err) => {
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      }

    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.getReceivable();
      this.getDeliveryDistricts();
      this.getProducts();
    },

    watch: {
      dialog (val) {
        if (val === false) {
          this.cleanReceivableSelected();
        }
      },
      shoppingBagDialog (val) {
        if (val === false) {
          this.cleamShoppingBag()
        }
      },
      'address.department_id': function (val) {
        if (val) {
          const self = this;
          this.provinces.forEach(function(obj) {
            if (obj.department_id == val) {
              self.select.provinces.push(obj);
            }
          });
        }
      },
      'address.province_id': function (val) {
        if (val) {
          const self = this;
          this.districts.forEach(function(obj) {
            if (obj.province_id == val) {
              self.select.districts.push(obj);
            }
          });
        }
      },
      'address.district_id': function (newDistrictId, oldDistrictId) {
        if (newDistrictId != oldDistrictId) {
          if (this.address.shipping_type_id == 1) {
            const self = this;
            this.deliveryDistricts.forEach(function(obj) {
              if (obj.district_id == newDistrictId) {
                if (obj.size == 2) {
                  self.partialOrder.shipping_price = obj.price;
                  const coupon = self.partialOrder.coupon > 0 ? self.partialOrder.coupon : 0;
                  const total = (parseFloat(self.partialOrder.subtotal) + parseFloat(obj.price)) - parseFloat(coupon);
                  self.partialOrder.total = parseFloat(total).toFixed(2);
                }
              }
            });
          } else if (this.address.shipping_type_id == 2) {
            this.address.address = 'Almacén Villa el Salvador\nAv. Mariano Pastor Sevilla & Av. Talara, Villa EL Salvador 15837'
          }
        }
      },
      'selected.product' (val) {
        if (val) {
          const self = this;
          this.select.productColors = [];
          this.select.productColorSizes = [];
          this.select.products.forEach(function(obj) {
            if (obj.id == self.selected.product) {
              self.unit_price = obj.off > 0 ? obj.sale_price : obj.regular_price;
              self.off = obj.off;
              return;
            }
          });
          this.getProductColors();
          this.getProductColorSizes();
        }
      },
      'selected.productColor' (val) {
        if (val) {
          const self = this;

          this.select.productColorSizes = [];
          this.productColorSizes.forEach(function(obj) {
            if (obj.product_color_id == val) {
              self.select.productColorSizes.push(obj);
            }
          });

          if (this.select.productColorSizes.length == 1 && this.select.productColorSizes[0].size.name == 'NOT_SIZE') {
            this.selected.productColorSize = this.select.productColorSizes[0].id;
          }

          this.getProductImagesForTypeAndColor();
        }
      },
      'selected.productColorSize' (val) {
        if (val) {
          const self = this;
          this.productColorSizes.forEach(function(obj) {
            if (obj.id == val) {
              self.stock = obj.stock;
            }
          });
        }
      },
      'partialOrder.shipping_price' (newShippingPrice, oldShippingPrice) {
        if (newShippingPrice != oldShippingPrice) {
          this.calculeAmounts();
        }
      },
      'partialOrder.coupon' (newCoupon, oldCoupon) {
        if (newCoupon !== oldCoupon) {
          this.calculeAmounts();
        }
      },
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/order/Receivable.vue